<template>
    <slot v-bind="{ ...state, setDialog, handleClose }" />
</template>

<script setup>
import { onBeforeUnmount, onMounted, reactive } from 'vue';

import favorites from '../services/favorites';

const state = reactive({
    type: null,
});

let dialog = null;

const setDialog = element => {
    dialog = element;
}

const handleClose = () => {
    dialog.close();
}

const handleFavoritesChange = event => {
    const { detail: { type, change } } = event;

    if (change === 'added' && !favorites.isDialogShown()) {
        state.type = type;

        dialog.showModal();
        favorites.setDialogShown();
    }
}

onMounted(() => {
    window.addEventListener(favorites.favoritePerformancesChangedEventName, handleFavoritesChange);
    window.addEventListener(favorites.favoriteArtistsChangedEventName, handleFavoritesChange);
});

onBeforeUnmount(() => {
    window.removeEventListener(favorites.favoritePerformancesChangedEventName, handleFavoritesChange);
    window.removeEventListener(favorites.favoriteArtistsChangedEventName, handleFavoritesChange);
});
</script>
